/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
/* eslint-disable camelcase */

export const FILTER_SEARCH = 'FILTER_SEARCH';
export const HANDLE_ERROR_MESSAGE_FOR_UC = 'HANDLE_ERROR_MESSAGE_FOR_UC';
export const SEARCH_REDUX = 'SEARCH_REDUX';
export const SEARCH_REDUX1 = 'SEARCH_REDUX1';
export const SELECT_BY_OPTIONS = 'SELECT_BY_OPTIONS';
export const SEARCH_TYPE_OPTIONS = 'SEARCH_TYPE_OPTIONS';
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const SELECTED_NDC_LIST = 'SELECTED_NDC_LIST';
export const SEARCH_SELECTED_NDC = 'SEARCH_SELECTED_NDC';
export const SHOW_CONVERSION_LIST = 'SHOW_CONVERSION_LIST';
export const GET_ALL_UC_MANUFACTURER_LIST = 'GET_ALL_UC_MANUFACTURER_LIST';
export const UPDATE_UC_NDC = 'UPDATE_UC_NDC';
export const GET_ALL_UC_EXISTING_ROWS = 'GET_ALL_UC_EXISTING_ROWS';
export const GET_ALL_UC_NDC = 'GET_ALL_UC_NDC';
export const GET_ALL_UC_LABELER_LIST = 'GET_ALL_UC_LABELER_LIST';
export const NDC_ERROR_POPUP_MESSAGE = 'NDC_ERROR_POPUP_MESSAGE';
export const NDC_SUCCESS_MESSAGE = 'NDC_SUCCESS_MESSAGE';
export const NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA =
  'NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA';
export const GET_UC_NDC_BY_LABELLER = 'GET_UC_NDC_BY_LABELLER';
export const UPDATED_TEMP_NDC = 'UPDATED_TEMP_NDC';
export const DELETED_NDC = 'DELETED_NDC';
export const ADDED_NDC = 'ADDED_NDC';
export const GET_ALL_REBATE_DROPDOWN = 'GET_ALL_REBATE_DROPDOWN';
export const GET_NDCs_UC_LIST_SEARCH_BY_NAME_OR_NDCs =
  'GET_NDCs_UC_LIST_SEARCH_BY_NAME_OR_NDCs';
export const GET_ALL_CLAIM_DROPDOWN = 'GET_ALL_CLAIM_DROPDOWN';
export const UPDATED_TABLE = 'UPDATED_TABLE';
export const ERROR_MSG = 'ERROR_MSG';
export const VIEW_HISTORY = 'VIEW_HISTORY';
export const ERROR_MESSAGES_UC = 'ERROR_MESSAGES_UC';
export const GET_NDC_MFG_ID = 'GET_NDC_MFG_ID';
export const GET_SINGLE_NDC_MFG_ID = 'GET_SINGLE_NDC_MFG_ID';
export const GET_NDC_GRID_DATA = 'GET_NDC_GRID_DATA';
export const BUTTON_STATE = 'BUTTON_STATE';
export const STATUS_BIT = 'STATUS_BIT';
export const MFG_SELECTED = 'MFG_SELECTED';
export const SUCCESS_RESPONSE_DETAIL = 'SUCCESS_RESPONSE_DETAIL';
export const RESET_UNIT_CONVERSION_DATA = 'RESET_UNIT_CONVERSION_DATA';
export const FIRST_TIME_ADD = 'FIRST_TIME_ADD';
export const GET_EXITING_ROW = 'GET_EXITING_ROW';
export const GET_CMS_UNIT_TYPES = 'GET_CMS_UNIT_TYPES';
